import React from "react";
import { Modal, Table, Button } from "react-bootstrap";

export default function ActivityModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Account Activity</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Table responsive>
          <thead>
            <tr>
              <th>Device</th>
              <th>Date</th>
              <th>Location</th>
              <th>IP Address</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Chrome - Windows</td>
              <td>15 May 2025</td>
              <td>USA</td>
              <td>232.222.12.72</td>
              <td>
                <Button size="sm" variant="success">
                  connect
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
}